/**
 * InstructionApiClient -- HTTP client for /api/v1/Instructions.
 *
 * @module infrastructure/api/InstructionApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/Instructions';

export const InstructionApiClient = {
  async list(page = 1, pageSize = 20, status = '') {
    const qs = status ? `&status=${encodeURIComponent(status)}` : '';
    return ApiBase.get(`${BASE}?page=${page}&pageSize=${pageSize}${qs}`);
  },

  async getById(id) {
    return ApiBase.get(`${BASE}/${id}`);
  },

  async create(instruction) {
    return ApiBase.post(BASE, instruction);
  },

  async update(id, instruction) {
    return ApiBase.put(`${BASE}/${id}`, instruction);
  },

  async remove(id) {
    return ApiBase.del(`${BASE}/${id}`);
  },

  /**
   * GET /api/v1/Instructions/lectura (nexo-api 651): la lista unica de lo que lee un agente (v_lectura_agente), sin texto,
   * con estado_git por fila. La lee application/instrucciones/lecturaDelAgente.js.
   */
  async lectura() {
    return ApiBase.get(`${BASE}/lectura`);
  },

  /** PATCH /api/v1/Instructions/{id}/rag-status — actualiza rag_version + rag_ingested_at */
  async patchRagStatus(id, { ragVersion, ragIngestedAt }) {
    return ApiBase.patch(`${BASE}/${id}/rag-status`, { ragVersion, ragIngestedAt });
  }
};
